import { Dropdown as DropdownA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { resolveClassNames } from '../utils';
import styles from './dropdown.module.css';
import { useTranslateDropdownMenuItems } from './hooks';
import { PositionAtClickDropdown } from './position-at-click-dropdown';

export type DropdownProperties = {
  positionAtClick?: boolean;
} & ComponentProps<typeof DropdownA>;

const Dropdown = ({ children, classNames, menu, placement, positionAtClick = false, ...rest }: DropdownProperties) => {
  const translatedItems = useTranslateDropdownMenuItems({ items: menu?.items });

  const sharedProperties = {
    classNames: resolveClassNames(classNames, (resolvedClassNames) => ({
      ...resolvedClassNames,
      itemIcon: cn(styles['menu-item-icon'], resolvedClassNames?.itemIcon),
      root: cn(styles.root, resolvedClassNames?.root),
    })),
    menu: menu
      ? {
          ...menu,
          className: cn(styles.menu, menu.className),
          items: translatedItems,
        }
      : undefined,
    ...rest,
  };

  if (positionAtClick) {
    return <PositionAtClickDropdown {...sharedProperties}>{children}</PositionAtClickDropdown>;
  }

  return (
    <DropdownA {...sharedProperties} placement={placement}>
      {children}
    </DropdownA>
  );
};

export default Dropdown;
